import {
  Accordion,
  AccordionItem,
  Card,
  CardBody,
  cn,
  Skeleton,
} from '@heroui/react';
import { Footer } from '@milestone-portal/ui/Footer/Footer';

export function MobileNftDetailSkeleton() {
  return (
    <div className="flex w-full flex-col">
      <div className="flex px-4">
        <Skeleton className="h-12 w-24 rounded-lg" />
        <Skeleton className="ml-auto h-12 w-36 rounded-lg" />
      </div>
      <div className="relative mx-auto mb-4 flex min-h-screen w-full flex-col gap-y-4 overflow-hidden p-4 lg:mb-8 lg:px-8">
        <Card shadow="none">
          <CardBody className="overflow-hidden py-12">
            <div className="flex justify-center">
              <Skeleton className="size-[256px] rounded-lg" />
            </div>
          </CardBody>
        </Card>
        <div className="w-full overflow-hidden">
          <div className="mb-2 flex justify-center">
            <Skeleton className="h-8 w-3/4 rounded-lg" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-full rounded-lg" />
            <Skeleton className="h-4 w-full rounded-lg" />
            <Skeleton className="mx-auto h-4 w-3/4 rounded-lg" />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <Card shadow="none">
            <CardBody className="flex flex-row gap-4 overflow-hidden">
              <div className="flex !w-[48px] items-center justify-center sm:!w-[64px]">
                <Skeleton className="bg-default-500 !size-[48px] rounded-full p-[2px] sm:!size-[64px]" />
              </div>
              <div className="flex flex-col justify-center gap-2">
                <Skeleton className="h-6 w-32 rounded-lg" />
                <Skeleton className="text-default-600 h-4 w-24 rounded-lg" />
              </div>
            </CardBody>
          </Card>
          <Card shadow="none">
            <CardBody className="flex flex-row gap-4 overflow-hidden">
              <div className="flex !w-[48px] items-center justify-center sm:!w-[64px]">
                <Skeleton className="bg-default-500 !size-[48px] rounded-full p-[2px] sm:!size-[64px]" />
              </div>
              <div className="flex flex-col justify-center gap-2">
                <Skeleton className="h-6 w-32 rounded-lg" />
                <Skeleton className="text-default-600 h-4 w-24 rounded-lg" />
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-10 rounded-lg" />
          <Skeleton className="size-10 rounded-lg" />
          <Skeleton className="size-10 rounded-lg" />
          <Skeleton className="size-10 rounded-lg" />
        </div>
        <Accordion
          defaultChecked
          itemClasses={{
            base: cn`-mx-2`,
          }}
          keepContentMounted
          selectedKeys={new Set(['0', '1', '2', '3'])}
          selectionMode="multiple"
          showDivider={false}
        >
          <AccordionItem
            key="0"
            title={<Skeleton className="h-5 w-1/2 rounded-lg" />}
          >
            <Card shadow="none">
              <CardBody>
                <div className="flex flex-col gap-3">
                  <Skeleton className="h-5 w-full rounded-lg" />
                  <Skeleton className="h-5 w-full rounded-lg" />
                  <Skeleton className="h-5 w-3/4 rounded-lg" />
                </div>
              </CardBody>
            </Card>
          </AccordionItem>
          <AccordionItem
            key="1"
            title={<Skeleton className="h-5 w-1/2 rounded-lg" />}
          >
            <div className="flex flex-col gap-3">
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>
          </AccordionItem>
          <AccordionItem
            key="2"
            title={<Skeleton className="h-5 w-1/2 rounded-lg" />}
          >
            <div className="flex flex-col gap-3">
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>
          </AccordionItem>
          <AccordionItem
            key="3"
            title={<Skeleton className="h-5 w-1/2 rounded-lg" />}
          >
            <div className="flex flex-col gap-3">
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>
          </AccordionItem>
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
